import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { managerActions } from '@/store/reducers/manager'

interface PathParams extends Record<string, string> {
  projectId: string
}

export const useInitPreview = () => {
  const { projectId = '' } = useParams<PathParams>()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(managerActions.previewInit({ id: projectId }))
  }, [])
}
